import React from 'react'
import MainTabPanel from './MainTabPanel';
import { Typography } from '@mui/material';
// import TimelineChart from '../../components/chart/TimelineChart';
const Home = () => {

  return (
    <>
      <div className="page-header pb-0 mb-3">
        <div className="row align-items-center">
          <div className="col">
            <Typography className="fw-semibold mb-0" sx={{ fontSize: { xl: '24px', lg: '24px', md: '24px', sm: '24px', xs: '20px' }, color: '#1A1F36' }}>Dashboard</Typography>
          </div>
          {/* End Col */}
          <div className="col-auto d-flex align-items-center gap-1">
            {/* <span><img src="/assets/images/dashboard/header-img1.png" className="img-fluid" alt="header-img1" /></span>
            <span><img src="/assets/images/dashboard/header-img2.png" className="img-fluid" alt="" /></span>
            <span><img src="/assets/images/dashboard/header-img3.png" className="img-fluid" alt="" /></span> */}
            <Typography sx={{ fontSize: '13px', color: '#64748B', fontWeight: '400' }}>Mon, Apr 21, 2025 - Sun, Apr 27, 2025</Typography>
          </div>
          {/* End Col */}
        </div>
        {/* End Row */}
      </div>
      <MainTabPanel />
    </>
  )
}

export default Home
